import { Component, EventEmitter, HostListener, inject, Inject, Input, Output } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UtilService } from '@app/shared/services/utils/util.service';

@Component({
  selector: 'cm-header-popup',
  templateUrl: './header-popup.component.html',
  styleUrls: ['./header-popup.component.scss'],
})
export class HeaderPopupComponent {
  @Input() isSideNavStyle = false;
  @Output() closeDialogEmitter = new EventEmitter<void>();
  isMobile = false;
  public data = inject(MAT_DIALOG_DATA) as any;

  constructor(
    protected dialogRef: MatDialogRef<HeaderPopupComponent>
  ) {
    this.isMobile = UtilService.isMobileAndTabletSize();
  }

  @HostListener('window:resize', ['$event']) onResize() {
    this.isMobile = UtilService.isMobileAndTabletSize();
    this.onCloseDialog();
  }

  onCloseDialog(): void {
    this.isMobile = UtilService.isMobileAndTabletSize();
    if (this.isMobile && this.dialogRef.close) {
      this.dialogRef.close();
    } else {
      this.closeDialogEmitter.emit();
    }
  }
}
